import api from "../atlasApi";

export const serviceGetDatabases = (data) => {
  return api.post("/horizon/database/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
      "Content-Type": "multipart/form-data",
    },
  });
};

